/* Local inline icons for /ai (no icon dependency, BottomTabs convention). */

function Icon({ children, className = "lz-coach-icon" }) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      {children}
    </svg>
  );
}

export function MemoryIcon() {
  return (
    <Icon>
      <path d="M7 3.75h10a1.25 1.25 0 0 1 1.25 1.25v15.25L12 16.5l-6.25 3.75V5A1.25 1.25 0 0 1 7 3.75Z" />
      <path d="M9.25 8.5h5.5M9.25 11.5h3.5" />
    </Icon>
  );
}

export function MoreIcon() {
  return (
    <Icon>
      <circle cx="5.5" cy="12" r="1.1" />
      <circle cx="12" cy="12" r="1.1" />
      <circle cx="18.5" cy="12" r="1.1" />
    </Icon>
  );
}

export function SendIcon() {
  return (
    <Icon>
      <path d="M12 19V5.5M6 11l6-6 6 6" />
    </Icon>
  );
}

export function RetryIcon() {
  return (
    <Icon className="lz-coach-icon lz-coach-icon--sm">
      <path d="M4.75 12a7.25 7.25 0 1 0 2.2-5.2" />
      <path d="M4.75 4.5v4h4" />
    </Icon>
  );
}

export function PinIcon() {
  return (
    <Icon className="lz-coach-icon lz-coach-icon--xs">
      <path d="M9 4.5h6l-1 5 3 3v1.5H7V12.5l3-3-1-5Z" />
      <path d="M12 14v5.5" />
    </Icon>
  );
}

export function CheckinIcon() {
  return (
    <Icon>
      <rect x="4.25" y="5" width="15.5" height="15" rx="2.5" />
      <path d="M8 3.25v3.5M16 3.25v3.5M4.25 10h15.5M9 14.5l2 2 4-4" />
    </Icon>
  );
}

export function ArrowRightIcon() {
  return (
    <Icon className="lz-coach-icon lz-coach-icon--xs">
      <path d="m9 5.5 6.5 6.5L9 18.5" />
    </Icon>
  );
}
